/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */
let baseUrl = 'https://saas.hansifit.com/api/';
let wsUrl = 'wss://saas.hansifit.com/JbvZhE';

if (process.env.NODE_ENV == 'development') {
    baseUrl = 'http://127.0.0.1:8080/';
    wsUrl = 'ws://127.0.0.1:8082/ws';
} else if (process.env.NODE_ENV == 'production') {
    baseUrl = 'https://saas.hansifit.com/api/';
    wsUrl = 'wss://saas.hansifit.com/JbvZhE';
}
export {
    baseUrl,
    wsUrl,
};
